angular.module('unergie.main')
.factory('TimelineConsService', () => {
    const margin = {
        top: 10,
        right: 20,
        bottom: 40,
        left: 30,
    }

    const formatTs = (ts) => moment(ts * 1000).format('DD/MM/YY')

    const prepareData = function (rawData) {
        const startDate = moment(rawData.startDate, 'YYYY-MM-DD')
        const data = {}
        _.forEach(rawData, (tempClass, tempClassName) => {
            if (angular.isObject(tempClass)) {
                return _.forEach(rawData[tempClassName], (values, key) => {
                    if (angular.isArray(values)) {
                        const currentDate = moment(startDate).add(-1, 'days')
                        data[tempClassName] = data[tempClassName] || {}
                        data[tempClassName][key] = data[tempClassName][key] || []
                        return values.forEach((value) => {
                            data[tempClassName][key].push({
                                value,
                                date: currentDate.add(1, 'days').unix(),
                            })
                        })
                    }
                })
            }
        })
        return data
    }

    const display = function (svg, width, height, rawData) {
        const widthNoMargin = width - margin.left - margin.right
        const heightNoMargin = height - margin.top - margin.bottom

        const data = prepareData(rawData)

        const g = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`)

        const x = d3.scaleLinear().range([0, widthNoMargin])
        const y = d3.scaleLinear().range([heightNoMargin, 0])

        const valueline = d3.line()
        .x((d) => x(d.date))
        .y((d) => y(d.value))

        const startDate = moment(rawData.startDate, 'YYYY-MM-DD')
        const endDate = moment(rawData.endDate, 'YYYY-MM-DD')

        // const totalWidth = endDate.unix() - startDate.unix()

        let heightsArray = []
        _.forEach(data, (tempClass) => {
            _.forEach(tempClass, (values) => (heightsArray = heightsArray.concat(_.map(values, 'value'))))
        })


        x.domain([startDate.unix(), endDate.unix()])
        y.domain([0, d3.max(heightsArray)])

        const tooltipLine = (tempClass, elem) => {
            return `${tempClass}<br/>${moment.unix(elem.date).format('DD/MM/YYYY')}<br/>${elem.value}kWh`
        }


        const tooltipOn = function (tooltipFunc, d) {
            svg.tooltip.transition()
            .duration(200)
            .style('opacity', 0.9)

            return svg.tooltip.html(tooltipFunc(d))
            .style('left', `${d3.event.pageX + 20}px`)
            .style('top', `${d3.event.pageY - 28}px`)
        }

        const tooltipOff = (d) => {
            return svg.tooltip.transition()
            .duration(500)
            .style('opacity', 0)
        }

        _.forEach(data, (tempClass, tempClassName) => {
            _.forEach(tempClass, (rawValues, nature) => {
                if (rawValues.length > 0) {
                    // Filter out -1 values
                    const values = _.filter(rawValues, (elem) => elem.value !== -1)
                    if (nature === 'estimated') {
                        g.append('path')
                        .attr('class', `${tempClassName.toLowerCase()} ${nature}`)
                        .attr('stroke', 'green')
                        .attr('d', valueline(values))
                    }

                    return g.selectAll('dot')
                    .data(values)
                    .enter().append('circle')
                    .attr('class', `${tempClassName.toLowerCase()} ${nature}`)
                    .attr('r', 2.5)
                    .attr('cx', (d) => x(d.date))
                    .attr('cy', (d) => y(d.value))
                    .on('mouseover', tooltipOn.bind(null, tooltipLine.bind(null, `${tempClassName} ${nature}`)))
                    .on('mouseout', tooltipOff)
                }
            })
        })

        g.append('g')
        .attr('class', 'x axis')
        .attr('transform', `translate(0,${heightNoMargin})`)
        .call(d3.axisBottom(x)
        .tickFormat(formatTs))

        g.append('g')
        .attr('class', 'y axis')
        .call(d3.axisLeft(y))

        return g.selectAll('.x text').attr('transform', 'translate(-13,11)rotate(-45)')
    }

    const show = function (svg, className, notClassNames) {
        let selectToShow = `.${className}`
        selectToShow += (_.map(notClassNames, (c) => `:not(.${c})`)).join('')
        return svg.selectAll(selectToShow).classed('hidden', false)
    }

    const hide = function (svg, className, notClassNames) {
        let selectToHide = `.${className}`
        selectToHide += (_.map(notClassNames, (c) => `:not(.${c})`)).join('')
        return svg.selectAll(selectToHide).classed('hidden', true)
    }

    return {
        display,
        show,
        hide,
    }
})
